export default "__VITE_ASSET__6cdeb682__"